import { render } from "./coach-mybooking-coaching.vue?vue&type=template&id=7cdde78c"
import script from "./coach-mybooking-coaching.vue?vue&type=script&lang=js"
export * from "./coach-mybooking-coaching.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__